import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";

var _templateObject,
    _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/NodeExpand/NodeExpand.styled.ts",
    _templateObject2,
    _templateObject3,
    _templateObject4;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import styled from 'styled-components';
export var ShevronWrapper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  width: 5px;\n  height: 8px;\n  transform: ", ";\n\n  & path {\n    ", ";\n  }\n"])), function (props) {
  return props.expanded ? 'rotate(90deg)' : 'initial';
}, function (props) {
  return props.hovered && 'fill: #353B60;';
});
export var ExpandDotWrap = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  width: 24px;\n  height: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"])));
export var ExpandDot = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  width: 6px;\n  height: 6px;\n  border-radius: 3px;\n  background-color: #353b60;\n  opacity: 0.25;\n"])));
export var ExpandButton = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  visibility: ", ";\n"])), function (props) {
  return props.hide ? 'hidden' : 'visible';
});